<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Cost Management</b-card-title>
      </b-card-header>
      <apexchart
        type="line"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "CostManagementChart",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  props: {
    costData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      series: [
        {
          name: "Total Cost",
          data: [],  
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], 
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "Month",
          },
        },
        yaxis: {
          title: {
            text: "Cost Amount",
          },
        },
      },
    };
  },
  watch: {
    costData: {
      handler(newData) {
        this.processChartData(newData);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    processChartData(data) {
      if (!data || data.length === 0) return;
      
      const sortedData = [...data].sort((a, b) => 
        new Date(a.date) - new Date(b.date)
      );
      
      const categories = sortedData.map(item => item.name);
      
      const costValues = sortedData.map(item => item.amount);
      
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories: categories,
        }
      };
      
      this.series = [
        {
          name: "Total Cost",
          data: costValues,
        }
      ];
    }
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>